module.exports = __webpack_public_path__ + "7b485df1cddf9bd540662099130cc03e.png";